import CheckFeature from '../checkfeature'
import store from '@/store'

export default class HighQualityCasters extends CheckFeature {

  hasFeature (): boolean {
    return store.state.team.team.high_quality_casters ?? false
  }

  teamHasFeature (teamId: string): boolean {
    const team = store.state.team.allTeams.find(team => team.id == teamId)
    return team?.high_quality_casters ?? false
  }

  updateTeamFeature (teamId: string, enabled: boolean) : void {
    store.dispatch.team.updateTeam({
      id: teamId,
      high_quality_casters: enabled
    })
  }

  isGlobalFeature () : boolean {
    return false
  }
}
